<template>
  <body id="app" :class="{ mobile: this.$options.isMobile }">
    <b-container fluid>
      <PartnerAd
        :title="title"
        :body="body"
        :buttonText="buttonText"
        :buttonUrl="buttonUrl"
        :presentedByText="presentedByText"
        :presentedByLogoImgSrc="presentedByLogoImgSrc"
        :nmlsLicense="nmlsLicense"
      />
      <!-- shadowRoot="buyside-market-activity"-->
    </b-container>

    <component :is="'style'" lang="css" v-text="themeCSS"></component>
  </body>
</template>

<script>
import Vue from "vue"
import MobileDetect from "mobile-detect"
import BootstrapVue from "bootstrap-vue"
import VueMq from "vue-mq"
import "@/filters.js"

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueMq, {
  breakpoints: {
    xs: 768, //keep these the same as in _custom-variables.scss
    sm: 992,
    md: 1200,
    lg: 1440,
    xl: Infinity
  }
})

Vue.mixin({
  created() {
    let device = new MobileDetect(window.navigator.userAgent)
    this.$options.isMobile = device.mobile() !== null
  }
})

// Global components

import GraphLoader from "@/components/loaders/Graph.vue"
import SectionLoader from "@/components/loaders/SectionText.vue"
import BImgFallback from '@/components/shared/BImgFallback.vue'

Vue.component("VGraphLoader", GraphLoader)
Vue.component("VSectionLoader", SectionLoader)
Vue.component('VBImgFallback', BImgFallback)

import PartnerAd from "@/components/generic/PartnerAd"
import store from "@/store/index"
import {mapGetters} from 'vuex'

export default {
  name: "buyside-partner-ad",
  store,
  components: {
    PartnerAd
  },
  computed: {
    ...mapGetters('config', ['themeCSS']),
  },
  props: {
    title: {
      type: String
    },
    body: {
      type: String
    },
    buttonText: {
      type: String
    },
    buttonUrl: {
      type: String
    },
    presentedByText: {
      type: String
    },
    presentedByLogoImgSrc: {
      type: String
    },
    nmlsLicense: {
      type: String
    },
  }
}
</script>

<style lang="scss">
@import "@/styles/custom.scss";
#app {
  //font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
